import Vue from 'vue'
import Router from 'vue-router'
import Config from './config'
// import Dashboard from '@/views/Dashboard'
// import ComboPackage from '@/views/ComboPackage'
// import Sandwiches from '@/views/Sandwiches'
// import Lunchboxes from '@/views/Lunchboxes'
// import Drinks from '@/views/Drinks'
// import Cookies from '@/views/Cookies'
// import ProductList from '@/views/product/ProductList'

// import CartDetail from '@/views/checkout/CartDetail'
// import Checkout from '@/views/checkout/Checkout'
// import Register from '@/views/profile/Register'
// import ForgotPassword from '@/views/profile/ForgotPassword'
// import GiantSub from '@/views/GiantSub'
// import CheckoutSuccess from '@/views/checkout/CheckoutSuccess'
// import OurLocation from '@/views/company/OurLocation'
// import ContactUs from '@/views/company/ContactUs'
// import FAQ from '@/views/company/FAQ'
// import UserTerm from '@/views/company/UserTerm'
// import PrivacyPolicy from '@/views/company/PrivacyPolicy'
// profile
// import MyOrders from '@/views/profile/Orders'
// import MyOrderDetail from '@/views/profile/OrderDetail'
// import MyCredit from '@/views/profile/Credit'
// import MyInformation from '@/views/profile/Information'

Vue.use(Router)

export function CreateRouter () {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/Dashboard')
      },
      {
        path: '',
        name: 'emptydashboard',
        component: () => import('@/views/Dashboard')
      },
      {
        path: Config.CartDetail,
        name: 'cartdetail',
        component: () => import('@/views/checkout/CartDetail')
      },
      {
        path: Config.Checkout,
        name: 'checkout',
        component: () => import('@/views/checkout/Checkout')
      },
      {
        path: Config.Register,
        name: 'register',
        component: () => import('@/views/profile/Register')
      },
      {
        path: Config.ForgotPassword,
        name: 'forgotpassword',
        component: () => import('@/views/profile/ForgotPassword')
      },
      {
        path: Config.CheckoutSuccess,
        name: 'CheckoutSuccess',
        component: () => import('@/views/checkout/CheckoutSuccess')
      },
      {
        path: Config.OurLocation,
        name: 'OurLocation',
        component: () => import('@/views/company/OurLocation')
      },
      // profile
      {
        path: Config.MyOrders,
        name: 'MyOrders',
        component: () => import('@/views/profile/Orders')
      },
      {
        path: Config.MyOrderDetail,
        name: 'MyOrderDetail',
        component: () => import('@/views/profile/OrderDetail')
      },
      {
        path: Config.MyCredit,
        name: 'MyCredit',
        component: () => import('@/views/profile/Credit')
      },
      {
        path: Config.MyInformation,
        name: 'MyInformation',
        component: () => import('@/views/profile/Information')
      },
      {
        path: Config.ContactUs,
        name: 'ContactUs',
        component: () => import('@/views/company/ContactUs')
      },
      {
        path: Config.FAQ,
        name: 'FAQ',
        component: () => import('@/views/company/FAQ')
      },
      {
        path: Config.UserTerm,
        name: 'UserTerm',
        component: () => import('@/views/company/UserTerm')
      },
      {
        path: Config.PrivacyPolicy,
        name: 'PrivacyPolicy',
        component: () => import('@/views/company/PrivacyPolicy')
      },
      {
        path: '*',
        name: 'ProductList',
        component: () => import('@/views/product/ProductList')
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js